/* @flow */
import * as React from 'react';

import { observable } from 'mobx';
import { observer } from 'mobx-react';
import RequireForAccess from 'react-access';

import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import styles from './UserRadioGroup.module.scss';
import { actionsOnAccountUsers } from 'permissions/account';

@observer
class UserRadioGroup extends React.Component<*> {
  @observable localState = {
    value: this.props.value,
  };

  handleChange = (e: Object, field: Object) => {
    const value: string = e.target.value.toString();

    this.localState = {
      value,
    };
    field.set('value', value);
  };

  componentDidMount() {
    const { field, value }: Object = this.props;
    field.set('value', value);
  }

  render(): React.Element<*> {
    const field: Object = this.props.field;

    return (
      <div className={styles['user-radio-group']}>
        {field.options.map((option: Object) => (
          <div key={`id-${option.id}`}>
            <RequireForAccess permissions={actionsOnAccountUsers[Number(option.value)]}>
              <FormControlLabel
                key={option.id}
                label={option.label}
                control={
                  <Radio
                    checked={option.value == this.localState.value}
                    onChange={e => this.handleChange(e, field)}
                    value={option.value}
                    name="radio-button-demo"
                  />
                }
              />
              <p key={`id-extra-${option.id}`}>{option.extra}</p>
            </RequireForAccess>
          </div>
        ))}
      </div>
    );
  }
}

export default UserRadioGroup;
